export default __webpack_public_path__ + "static/media/field-user.5b8c5895.png";